import React, { useState, useEffect } from "react";
import "./FilterForm.css";

const FilterForm = ({ query, indexQuery, updateQueries }) => {
  const [columnSelect, setColumnSelect] = useState(query[0] || "url");
  const [filterCondition, setFilterCondition] = useState(query[1] || "==");
  const [input, setInput] = useState(query[2] || "");

  useEffect(() => {
    setColumnSelect("url");
    setFilterCondition("==");
    setInput("");
  }, [query]);

  useEffect(() => {
    updateQueries(indexQuery, 0, columnSelect);
  }, [columnSelect, indexQuery, updateQueries]);

  useEffect(() => {
    updateQueries(indexQuery, 1, filterCondition);
  }, [filterCondition, indexQuery, updateQueries]);

  useEffect(() => {
    updateQueries(indexQuery, 2, input);
  }, [input, indexQuery, updateQueries]);

  const queryColumns = [
    {
      display: "URL",
      field: "url"
    },
    {
      display: "Home Status",
      field: "status"
    },
    {
      display: "SSL Expiration",
      field: "ssl_expiration"
    },
    {
      display: "Site Speed",
      field: "site_speed"
    },
    {
      display: "Mobile Site Speed",
      field: "mobile_site_speed"
    },
    {
      display: "Floorlytics Status",
      field: "floorlytics.success"
    },
    {
      display: "Broken Links",
      field: "broken_links"
    }
  ];

  const queryConditions = ["==", ">", "<", ">=", "<="];

  const columnOptions = queryColumns.map((column, index) => (
    <option key={index} value={column.field}>
      {column.display}
    </option>
  ));

  const queryOptions = queryConditions.map((query, index) => (
    <option key={index} value={query}>
      {query}
    </option>
  ));

  const handleInputChange = e => {
    e.persist();
    const value = e.target.value;
    if (
      ["site_speed", "mobile_site_speed", "status", "broken_links"].includes(
        columnSelect
      )
    ) {
      const num = parseInt(value);
      setInput(isNaN(num) ? value : num);
    } else if (
      columnSelect === "floorlytics.success" &&
      (value === "true" || value === "false")
    ) {
      setInput(value === "true");
    } else {
      setInput(value);
    }
  };

  const handleColumnSelect = e => {
    setColumnSelect(e.target.value);
  };

  const handleConditionSelect = e => {
    setFilterCondition(e.target.value);
  };

  return (
    <div className="filter-form__wrapper">
      <select
        className="filter-column__column-select"
        onChange={handleColumnSelect}
        value={columnSelect}
      >
        {columnOptions}
      </select>

      <select
        className="filter-column__condition-select"
        onChange={handleConditionSelect}
        value={filterCondition}
      >
        {queryOptions}
      </select>

      <input
        type="text"
        name="filterValue"
        onChange={handleInputChange}
        value={input}
        placeholder="'200' or 'Expired'"
        className="filter-column__filter-value"
      />
    </div>
  );
};

export default FilterForm;
